import { useEffect, useRef } from 'react'

/**
 * Implementation based on https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export const useInterval = (callback: any, delay) => {
  const savedCallback = useRef<any>()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    const tick = () => {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
